import React from 'react';
export function RankingsSection() {
  return <section className="w-full relative" style={{
    marginTop: '37px'
  }} data-id="element-211">
      {/* Background image area */}
      <div className="relative w-full md:h-[472px]" style={{
      paddingBottom: '0'
    }} data-id="element-212">
        {/* Background image */}
        <img src="https://cdn.magicpatterns.com/uploads/9NoAU7WmHUi4efg8aGgMsB/Rectangle_70.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" style={{
        zIndex: 0
      }} data-id="element-213" />

        {/* Dark overlay */}
        <div className="absolute inset-0" style={{
        background: 'rgba(0, 0, 0, 0.45)',
        zIndex: 1
      }} data-id="element-214" />

        {/* Text content */}
        <div className="relative site-container flex flex-col items-center justify-center h-full" style={{
        zIndex: 2,
        minHeight: '472px'
      }} data-id="element-215">
          {/* Label */}
          <span style={{
          color: '#FFF',
          textAlign: 'left',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '18.75px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
          letterSpacing: '1.875px',
          textTransform: 'uppercase' as const
        }} data-id="element-216">
            Best Brands & Best Marketers 2026
          </span>

          {/* Title + Description wrapper */}
          <div style={{
          maxWidth: '800px',
          marginTop: '16px'
        }} data-id="element-217">
            <h2 style={{
            color: '#FFF',
            fontFamily: "'League Gothic', Impact, Arial, sans-serif",
            fontSize: '65px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '65px',
            textAlign: 'left'
          }} data-id="element-218">
              The US agencies storming up the World Creative Rankings
            </h2>

            <p style={{
            color: '#FFF',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
            textAlign: 'left',
            marginTop: '16px',
            maxWidth: '700px'
          }} data-id="element-219">
              Special Group, a global independent creative network, was the
              year's biggest climber in North America.
            </p>
          </div>
        </div>
      </div>
    </section>;
}